import { render } from "./pageHomeRegister.vue?vue&type=template&id=51faeaca"
import script from "./pageHomeRegister.vue?vue&type=script&lang=js"
export * from "./pageHomeRegister.vue?vue&type=script&lang=js"

import "./pageHomeRegister.vue?vue&type=style&index=0&id=51faeaca&scope=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QList,QItemLabel});
